/**
 * ImageObject type
 * DOC: https://schema.org/ImageObject
 */

export default ({
  id,
  url,
  caption,
  width,
  height
}) => ({
  '@type': 'ImageObject',
  ...(caption && {
    caption
  }),
  ...(id && {
    '@id': id
  }),
  ...(url && {
    url
  }),
  ...(width && {
    width
  }),
  ...(height && {
    height
  })
});